import { LoadingButton } from "@mui/lab";
import { Box, Checkbox, Radio, Typography } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { useTranslation } from "react-i18next";
import { FrequencySend } from "../../utils/enums/tabs";
import { DayOfWeekPicker } from "../daysOfWeek";
import { useStyles } from "./styles";
import { NotificationProps } from "./types";

export const Notification = (props: NotificationProps) => {

    const { t } = useTranslation()
    const styles = useStyles()


    return (
        <Box sx={styles.container}>
            <Box sx={styles.subContaine}>
                <Typography variant="title" fontWeight='bold'>{t('reportFolio.notificationCenter.notificationSummarySendingSettings')}</Typography>

                <Typography variant="subtitle_grey">{t('reportFolio.notificationCenter.configureTheWayAndFrequencyToSendNotificationSummary')}</Typography>

                <Typography variant="subtitle" fontWeight='bold'>{t('reportFolio.notificationCenter.shippingChannels')}</Typography>

                <Box>
                    {props.channelOptions.map(option => (
                        <Box key={option.id}>
                            <Checkbox
                                className='remove-m'
                                name="channel"
                                checked={option.check}
                                onChange={() => {
                                    props.handleChannelChecks(option.value)
                                }}
                                sx={styles.checkBox}
                            />
                            <Typography variant="subtitle_grey">{option.label}</Typography>
                        </Box>
                    ))}
                </Box>

                <Typography variant="subtitle" fontWeight='bold'>{t('reportFolio.notificationCenter.sendingFrequency')}</Typography>

                <Box>
                    {props.frequencyOptions.map(option => (
                        <Box key={option.id}>
                            <Box sx={styles.frequency}>
                                <Box>
                                    <Radio
                                        name="frequency"
                                        checked={option.check}
                                        onClick={() => {
                                            props.handleFrequencyChecks(option.value)
                                        }}
                                    />
                                    <Typography variant="subtitle_grey">{option.label}</Typography>
                                </Box>
                                {option.check && (<>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <TimePicker
                                            label="Configurar hora"
                                            value={props.valueDate}
                                            onChange={(newValue) => props.setValueDate(newValue)}
                                            minutesStep={1}
                                            sx={styles.timePicker}
                                            slotProps={{
                                                popper: {
                                                    sx: {
                                                        width: '210px',
                                                        '& .MuiList-root': {
                                                            width: '70px',
                                                        },
                                                        '& .MuiList-root::-webkit-scrollbar': {
                                                            width: '8px',
                                                            height: '8px',
                                                        },
                                                        '& .MuiList-root::-webkit-scrollbar-thumb': {
                                                            backgroundColor: '#888',
                                                            borderRadius: '10px',
                                                        },
                                                        '& .MuiList-root::-webkit-scrollbar-track': {
                                                            backgroundColor: '#f1f1f1',
                                                            borderRadius: '10px',
                                                        }
                                                    }
                                                }

                                            }}
                                        />
                                    </LocalizationProvider>

                                </>)}
                            </Box>
                            {option.value === String(FrequencySend.WEEKLY) && option.check && (
                                <DayOfWeekPicker selectedDay={props.selectedDay} setSelectedDay={props.setSelectedDay} />
                            )}
                        </Box>
                    ))}
                </Box>
            </Box>

            <Box sx={styles.saveButon}>
                <LoadingButton
                    onClick={() => {props.handleSubmit()
                    }}
                    variant="contained"
                    disabled={props.disableButton}
                    loading={props.loadingButton}
                >
                    {t('general.save')}
                </LoadingButton>
            </Box>
        </Box>
    )
}
